import { useQuery } from "@apollo/client";
import { SupportRequestsOpenCountQuery } from "../graphql/queries";
import type { SupportRequestsOpenCountQueryType } from "@/types/graphql/admin.generated";

/** Опрос раз в минуту: обращение может прийти, пока админка открыта. */
export const OPEN_REQUESTS_POLL_MS = 60_000;

export function useSupportRequestsOpenCount(): {
  count: number;
  refetch: () => void;
} {
  const { data, refetch } = useQuery<SupportRequestsOpenCountQueryType>(
    SupportRequestsOpenCountQuery,
    { pollInterval: OPEN_REQUESTS_POLL_MS, fetchPolicy: "cache-and-network" }
  );
  return {
    count: data?.supportRequestsOpenCount ?? 0,
    refetch: () => {
      void refetch();
    },
  };
}
